import React, { useState } from "react";
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from "recharts";
import PbPieChartProps from "./PbPieChartProps.type";
import styled from "@emotion/styled";
import { defaultFonts } from "../../../helpers/fonts";

const ChartContainer = styled.div({
  display: "flex",
  flexDirection: "column",
});

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      style={{
        fontFamily: defaultFonts,
      }}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const renderActiveShape = (props) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text
        x={cx}
        y={cy}
        dy={8}
        textAnchor="middle"
        style={{
          fontFamily: defaultFonts,
        }}
      >
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      {/*<path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >{`${(percent * 100).toFixed(2)}%`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`(${value})`}
  </text>*/}
    </g>
  );
};

const PbPieChart = (props: PbPieChartProps): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  const onPieEnter = (_, index) => {
    setActiveIndex(index);
  };
  return (
    <ChartContainer style={{ width: props.width, height: props.height }}>
      <PieChart width={props.width} height={props.width}>
        <Pie
          activeIndex={activeIndex}
          activeShape={props.activeShape ? renderActiveShape : null}
          data={props.sources}
          cx="50%"
          cy="50%"
          innerRadius={props.innerRadius}
          outerRadius={props.outerRadius}
          fill={"#AAAAAA"}
          dataKey="value"
          onMouseEnter={onPieEnter}
          onMouseLeave={() => {
            if (props.clearSelecction) {
              setActiveIndex(-1);
            }
          }}
          labelLine={false}
          label={props.label ? renderCustomizedLabel : null}
        >
          {props.sources.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.hexColor} />
          ))}
        </Pie>
      </PieChart>
    </ChartContainer>
  );
};

export default PbPieChart;
